import { ServiceApplication_Key } from "../../../../config/helpers";
import { apiSlice } from "../../api";

import { IFichierAlertePoches } from '../../../../models/interfaces/IFichierAlertePoches';
import { IFilterFichiersAlertePochesDTO } from "../../../../models/interfaces/IFilterFichiersAlertePoches";


export interface AlertePochesApiQueryBody {
  Application_Key: string;
  // eslint-disable-next-line
  Values: any;
}

export const FichierAlertePochesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    
   fetchFichiersAlertePoches: builder.query<IFichierAlertePoches, IFilterFichiersAlertePochesDTO|undefined>({
      query: (obj) => {
        const body: AlertePochesApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };

        return {
          url: "/AlertePoche/Get_Fichiers_AlertePoches",
          method: "POST",
          body: body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFetchFichiersAlertePochesQuery
} = FichierAlertePochesApi;
